<template>
    <section class="also__like__container">
        <div class="wrapper__texts">
                <div class="low__text" v-if="fields" data-animate="slideUp">{{ fields['Mini title'] }}</div>
                <div class="text" v-if="fields" data-animate="slideUp">{{ fields['Title'] }}</div>
                <a href="#" v-if="fields">
                    {{ fields['Button name'] }}
                    <svg width="15.000000" height="10.000000" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs/>
                        <path id="Union" d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
                    </svg>
                </a>
        </div>
        <slot name="list"></slot>
    </section>
</template>

<script>
    export default {
        props: {
            fields: [Array,Object],
        },
    }
</script>

<style scoped>
.also__like__container{
    padding-bottom: 120px;
    padding-top: 80px;
}
.wrapper__texts{
    position: relative;
    margin-bottom: 64px;
}
.wrapper__texts .low__text{
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 10px;
}
.wrapper__texts .text{
/* Header/H1: 44px Medium */
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    max-width: 555px;
}
.wrapper__texts a{
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}

@media (max-width: 1024px) {
    .wrapper__texts a{
        bottom: unset;
        top: 0;
    }
    .wrapper__texts{
        margin-bottom: 24px;
    }
    .wrapper__texts .text{
        font-size: 32px;
        max-width: 100%;
    }
}
@media (max-width: 768px) {
    .wrapper__texts .text{
        font-size: 24px;
    }
    .wrapper__texts{
        margin-bottom: 24px;
    }
}
</style>